import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/platon";
const defaultQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getPoints${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Платон.xlsx"),
    );
};
const getPoints = () => request(`${resource}/getPoints?$top=6000`, { method: "GET" });
const apply = (params: {}) => alertRequest(`${resource}/applyPoint`, body(params));
const getItem = ({ id }: { id: string }) => request(`${resource}/getPoint/${id}`, { method: "GET" });
const delItem = (params: {}) => alertRequest(`${resource}/deletePoint`, body(params));

export { apply, index, getItem, delItem, getPoints, getListExcel };
